export default __webpack_public_path__ + "static/media/icon_material.ec462880.svg";